import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useAPI } from '@/composables/useAPI';

export const useMiscStore = defineStore(
  'miscStore',
  () => {
    const surveyOpen = ref(false);
    const surveyEmailAddress = ref('');
    const surveyCountry = ref('');
    const bannerMessage = ref(false);
    const bannerAcknowledged = ref(false);
    const bannerID = ref();
    const bannerType = ref();
    const banners = ref([]);
    const notifications = ref([]);
    const matchedNotifications = ref([]);
    const socketStatus = ref({
      userFeedSocket: '',
      priceUpdateSocket: '',
    });
    const userSettingPopUp = ref(false);
    const commissionDiscounts = ref({
      mlb: {
        moneyline: 0.0075,
      },
    });
    // PAUSE ORDERS STATE - COMMENTED OUT
    // const resumeOffersModal = ref(false);
    // const pausedOffers = ref('hide');
    const withdrawalAddress = ref('');
    const withdrawalCurrency = ref({
      text: 'BITCOIN',
      name: 'BITCOIN',
      key: 'btc',
      id: '1',
    });
    const withdrawalAmount = ref(0);
    const withdrawalStage = ref(1);
    const userExceptions = ref([
      'trashdawg',
      'thfc',
      'highfade',
      'eggpeat',
      'buckdancer',
      'lvc',
      'zero',
      'exclusive',
      'ranger',
      'mango4c',
      'jds',
      'snowstorm',
      'minus110',
      'apollo',
      'kleymandavid',
      'whitecryptocow',
    ]);

    function setsurveyEmailAddress(emailVal) {
      surveyEmailAddress.value = emailVal;
    }

    function setsurveyCountry(emailVal) {
      surveyCountry.value = emailVal;
    }

    function toggleSurveyOpen() {
      surveyOpen.value = !surveyOpen.value;
    }

    function removeNotificationById(notificationId) {
      notifications.value = notifications.value.filter(
        (notification) => notification.id !== notificationId,
      );
    }

    function timedRemoveNotificationById(notificationId) {
      return setTimeout(() => {
        notifications.value = notifications.value.filter(
          (notification) => notification.id !== notificationId,
        );
      }, 3200);
    }

    function removeNotificationByIndex(index) {
      notifications.value.splice(index, 1);
    }

    function setMatchedNotification(payload) {
      matchedNotifications.value = JSON.parse(JSON.stringify(payload));
    }

    function removeMatchedNotificatiosnById(notificationId) {
      matchedNotifications.value = matchedNotifications.value.filter(
        (notification) => {
          return notification.id !== notificationId;
        },
      );
    }

    function clearMatchedNotifications() {
      matchedNotifications.value = [];
    }

    function setSocketStatus(payload) {
      const socketType = payload.type;
      if (socketType) {
        socketStatus.value[socketType] = payload.data;
      }
    }

    function setUserSettingsPopUp(payload) {
      userSettingPopUp.value = payload;
    }

    function setNotifications(payload) {
      let newNotifs = payload;
      if (!Array.isArray(payload)) {
        newNotifs = [payload];
      }
      notifications.value = newNotifs;
    }

    function addNotification(payload) {
      notifications.value.unshift(payload);
    }

    function addMatchedNotification(payload) {
      matchedNotifications.value.unshift(payload);
    }

    // PAUSE ORDERS FUNCTIONS - COMMENTED OUT
    // function setResumeOffersModal() {
    //   resumeOffersModal.value = !resumeOffersModal.value;
    // }

    // function setPausedOffers(payload) {
    //   pausedOffers.value = payload;
    // }

    function updateBanner(payload) {
      bannerAcknowledged.value =
        payload === undefined ? false : payload.acknowledged;
      bannerMessage.value = payload === undefined ? null : payload.message;
      bannerID.value = payload === undefined ? null : payload._id;
      bannerType.value = payload === undefined ? null : payload.type;
    }

    function addBannerToStore(payload) {
      if (Array.isArray(payload)) {
        banners.value = [];
        bannerAcknowledged.value = false;
        bannerMessage.value = null;
        bannerID.value = null;
        bannerType.value = null;

        const banner = payload[0];
        banners.value = payload.splice(1);
        updateBanner(banner);
      } else {
        const newBanner = payload;
        if (bannerID.value !== null && bannerID.value !== undefined) {
          const oldBanner = {
            acknowledged: bannerAcknowledged.value,
            message: bannerMessage.value,
            _id: bannerID.value,
            type: bannerType.value,
          };
          banners.value.unshift(oldBanner);
        }
        updateBanner({
          message: newBanner.message,
          _id: newBanner.bannerID,
          type: newBanner.type,
          acknowledged: newBanner.acknowledged || false,
        });
      }
    }

    function removeBannerFromStore() {
      try {
        const { request } = useAPI('user/acknowledgeBanner');
        request({
          bannerID: bannerID.value, // we are sending bannerID get the banner in the api and verify the type of banner to add to the user.
        });
        const banner = banners.value[0];
        const bannersCopy = [...banners.value];
        const banners = bannersCopy.splice(1);
        banners.value = banners;
        console.log(banner);
        updateBanner(banner);
      } catch {
        updateBanner(undefined);
      }
    }

    function reset() {
      bannerMessage.value = false;
      bannerAcknowledged.value = false;
      bannerID.value = undefined;
      bannerType.value = undefined;
      banners.value = [];
      notifications.value = [];
      matchedNotifications.value = [];
      socketStatus.value = {
        userFeedSocket: '',
        priceUpdateSocket: '',
      };
      userSettingPopUp.value = false;
      commissionDiscounts.value = {
        mlb: {
          moneyline: 0.0075,
        },
      };
      userExceptions.value = [
        'trashdawg',
        'thfc',
        'highfade',
        'eggpeat',
        'buckdancer',
        'lvc',
        'zero',
        'exclusive',
        'ranger',
        'mango4c',
        'minus110',
        'apollo',
        'jds',
        'whitecryptocow',
      ];
    }

    function setWithdrawalAmount(amt) {
      withdrawalAmount.value = amt;
    }

    function setWithdrawalAddress(addr) {
      withdrawalAddress.value = addr;
    }

    function setWithdrawalCurrency(val) {
      withdrawalCurrency.value = val;
    }

    function setWithdrawalStage(stage) {
      withdrawalStage.value = stage;
    }

    function clearWithdrawalData() {
      withdrawalAmount.value = 0;
      withdrawalAddress.value = '';
      withdrawalCurrency.value = {
        text: 'BITCOIN',
        name: 'BITCOIN',
        key: 'btc',
        id: '1',
      };
      withdrawalStage.value = 1;
    }

    return {
      surveyOpen,
      surveyEmailAddress,
      surveyCountry,
      bannerMessage,
      bannerAcknowledged,
      notifications,
      matchedNotifications,
      socketStatus,
      userSettingPopUp,
      commissionDiscounts,
      userExceptions,
      // PAUSE ORDERS STATE - COMMENTED OUT
      // pausedOffers,
      // resumeOffersModal,
      withdrawalAddress,
      withdrawalAmount,
      withdrawalCurrency,
      withdrawalStage,
      setSocketStatus,
      setUserSettingsPopUp,

      // Notifications
      addNotification,
      addMatchedNotification,
      removeNotificationById,
      setMatchedNotification,
      removeMatchedNotificatiosnById,
      removeNotificationByIndex,
      timedRemoveNotificationById,
      clearMatchedNotifications,
      setNotifications,

      // Banners
      addBannerToStore,
      removeBannerFromStore,
      reset,
      toggleSurveyOpen,
      setsurveyEmailAddress,
      setsurveyCountry,
      // PAUSE ORDERS FUNCTIONS - COMMENTED OUT
      // setResumeOffersModal,
      // setPausedOffers,
      setWithdrawalAddress,
      setWithdrawalAmount,
      setWithdrawalCurrency,
      setWithdrawalStage,
      clearWithdrawalData,
    };
  },
  {
    persist: {
      storage: sessionStorage,
    },
  },
);
